import { RemoteConfig } from '@angular/fire/remote-config';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RemoteConfigActions {
  export class SetRemoteConfig {
    static readonly type = '[RemoteConfig] SetRemoteConfig';
    constructor(public remoteConfig: RemoteConfig) {}
  }

  export class UpdateRemoteConfig {
    static readonly type = '[RemoteConfig] UpdateRemoteConfig';
    constructor(public remoteConfig: Partial<RemoteConfig>) {}
  }

  export class DeleteRemoteConfigs {
    static readonly type = '[RemoteConfig] DeleteRemoteConfigs';
    constructor(public key: string) {}
  }
}
